import * as z from "zod";
import { gql } from "graphql-request";

import { Sys, SysFragment } from "../sys";
import { Targeting, TargetingFragment } from "../targeting";
import {
  FullscreenEntryCarousel,
  FullscreenEntryCarouselFragment,
} from "./fullscreenCarousel";
import { RelatedMedia, RelatedMediaFragment } from "../relatedMedia";

export const FullscreenEntry = z.object({
  __typename: z.literal("FullscreenEntry"),
  sys: Sys,
  sortDate: z.string().nullable(),
  targeting: Targeting.nullish(),
  relatedMedia: RelatedMedia.nullish(),
  localized: z
    .discriminatedUnion("__typename", [FullscreenEntryCarousel])
    .nullish(),
});

export type FullscreenEntry = z.infer<typeof FullscreenEntry>;

export const FullscreenEntryFragment = gql`
  fragment FullscreenEntryFragment on FullscreenEntry {
    __typename
    sys {
      ...SysFragment
    }

    targeting {
      ...TargetingFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    sortDate
    localized {
      ... on FullscreenEntryCarousel {
        ...FullscreenEntryCarouselFragment
      }
    }
  }

  ${SysFragment}
  ${FullscreenEntryCarouselFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
